var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatecheckin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.419,
    height: 17.495,
    viewBox: "0 0 15.419 17.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2568",
    "data-name": "Group 2568",
    transform: "translate(7046.669 -6657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8420",
    "data-name": "Path 8420",
    d: "M289.047,18.686h.89v.944a7.247,7.247,0,0,1,1.779,0v-.944h.89a.3.3,0,0,0,.3-.3.889.889,0,0,0-.89-.89H289.64a.889.889,0,0,0-.89.89A.3.3,0,0,0,289.047,18.686Z",
    transform: "translate(-7329.786 6639.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8421",
    "data-name": "Path 8421",
    d: "M475.444,53.112a2.084,2.084,0,0,0-2.948,0l.881.881-.757.757a7.458,7.458,0,0,1,1.254,1.118l.689-.689.881.881A2.084,2.084,0,0,0,475.444,53.112Z",
    transform: "translate(-7507.305 6605.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8422",
    "data-name": "Path 8422",
    d: "M192.5,461.394a1.481,1.481,0,0,0,2.885.471,7.414,7.414,0,0,1-2.489-1.474A1.467,1.467,0,0,0,192.5,461.394Z",
    transform: "translate(-7236.797 6211.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8423",
    "data-name": "Path 8423",
    d: "M195.428,137.017a5.6,5.6,0,0,0-1.437-3.466l-.827.827-.419-.419.827-.827a5.6,5.6,0,0,0-3.466-1.437v1.171h-.593V131.7a5.6,5.6,0,0,0-3.466,1.437l.827.827-.419.419-.827-.827a5.6,5.6,0,0,0-1.437,3.466h1.171v.593H184.19a5.6,5.6,0,0,0,1.437,3.466l.827-.827.419.419-.827.827a5.6,5.6,0,0,0,3.466,1.437v-1.171h.593v1.171a5.6,5.6,0,0,0,3.466-1.437l-.827-.827.419-.419.827.827a5.6,5.6,0,0,0,1.437-3.466h-1.171v-.593Zm-5.619,1.186a.88.88,0,0,1-.381-.089l-1.485,1.485-.419-.419,1.485-1.485a.879.879,0,0,1,.5-1.216v-3.02h.593v3.02a.887.887,0,0,1-.3,1.725Z",
    transform: "translate(-7228.769 6529.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8424",
    "data-name": "Path 8424",
    d: "M422.36,461.86a1.48,1.48,0,1,0,2.489-1.474,7.414,7.414,0,0,1-2.489,1.474Z",
    transform: "translate(-7458.868 6211.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8425",
    "data-name": "Path 8425",
    d: "M155.57,96.25a6.82,6.82,0,1,0,6.82,6.82A6.828,6.828,0,0,0,155.57,96.25Zm0,13.047a6.227,6.227,0,1,1,6.227-6.227A6.234,6.234,0,0,1,155.57,109.3Z",
    transform: "translate(-7194.53 6563.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8426",
    "data-name": "Path 8426",
    d: "M124.682,55.867a7.445,7.445,0,0,1,1.254-1.118l-.757-.757.881-.881a2.084,2.084,0,1,0-2.948,2.948l.881-.881Z",
    transform: "translate(-7169.171 6605.685)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatecheckin);
export default __webpack_public_path__ + "static/media/latecheckin.23d68512b3fd2ab029e75a5679969715.svg";
export { ForwardRef as ReactComponent };